import { DataTableStatic, GenericModal } from 'components/organisms'
import ProductImageTableColumns from './product-image-table-columns'
import PropTypes from 'prop-types'
import React, { useState, useCallback, useMemo } from 'react'


const propTypes = {
  data           : PropTypes.array,
  rowButtonProps : PropTypes.array,
  hiddenColumns  : PropTypes.array,
  getRowProps    : PropTypes.func
}

const defaultProps = {
  hiddenColumns : [],
  getRowProps   : () => {}
}

/**
 * Domain-specific static datatable for Product Image.
 * @param {array} data - Array of product image
 * @param {object} rowButtonProps - Button props for Action row button
 * @param {array} hiddenColumns - Columns that aren't shown on the table
 * @param {func} getRowProps - function to returns an object to change the <tr> element
 */
const ProductImageTable = ({
  data,
  rowButtonProps,
  hiddenColumns,
  getRowProps
}) => {

  const [ selectedImageSrc, setSelectedImageSrc ] = useState()
  const [ isOpen, setIsOpen ]                     = useState(false)

  const handleClickImage = useCallback((data) => {
    setSelectedImageSrc(data)
    toggle()
  }, [])

  const toggle = () => setIsOpen((prev) => !prev)

  const columns = useMemo(
    () => ProductImageTableColumns({
      rowButtonProps,
      handleClickImage
    }), [ rowButtonProps, handleClickImage ])

  return (
    <>
      <DataTableStatic
        data={ data }
        columns={ columns }
        defaultPageSize={ 100 }
        showPagination={ false }
        hiddenColumns={ hiddenColumns }
        getRowProps={ getRowProps }
      />

      <GenericModal
        isOpen={ isOpen }
        toggle={ toggle }
        size='lg'
      >
        <img
          width='100%'
          src={ selectedImageSrc }
          alt='product thumbnails'
        />
      </GenericModal>
    </>
  )

}

ProductImageTable.propTypes    = propTypes
ProductImageTable.defaultProps = defaultProps

export default ProductImageTable
